import React from 'react';
import { CalendarIcon, ClockIcon, MoreHorizontalIcon, TargetIcon, WrenchIcon } from 'lucide-react';
import { View } from '../types/view';
interface BottomNavProps {
  currentView: View;
  onNavigate: (view: View) => void;
  onOpenMore: () => void;
  isMoreOpen: boolean;
}
interface Tab {
  id: View;
  label: string;
  icon: typeof WrenchIcon;
  /** Detail views that should keep this tab highlighted. */
  alsoActiveFor?: View[];
}

/** On site, a tradesperson needs jobs, hours, schedule and new enquiries. */
const tabs: Tab[] = [{
  id: 'pro-jobs',
  label: 'Opgaver',
  icon: WrenchIcon,
  alsoActiveFor: ['pro-job-detail']
}, {
  id: 'pro-time',
  label: 'Timer',
  icon: ClockIcon
}, {
  id: 'pro-calendar',
  label: 'Kalender',
  icon: CalendarIcon
}, {
  id: 'pro-leads',
  label: 'Leads',
  icon: TargetIcon
}];

/**
 * Mobile primary navigation. Keeps the four most-used destinations one tap
 * away so the phone experience isn't a single long scroll through a menu.
 */
export function BottomNav({
  currentView,
  onNavigate,
  onOpenMore,
  isMoreOpen
}: BottomNavProps) {
  return <nav aria-label="Primær navigation" className="fixed bottom-0 left-0 right-0 z-40 border-t border-stone-200 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden" data-id="element-15" data-mp="czv2vcna02oo">
      <ul className="flex items-stretch" data-id="element-16" data-mp="3y557p2sw7ig">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = !isMoreOpen && (currentView === tab.id || (tab.alsoActiveFor?.includes(currentView) ?? false));
        return <li key={tab.id} className="flex-1" data-id="element-17" data-mp="hz7ro2xpjjtw">
              <button onClick={() => onNavigate(tab.id)} aria-current={isActive ? 'page' : undefined} className={`flex w-full flex-col items-center gap-1 px-1 py-2.5 transition-colors ${isActive ? 'text-brand-700' : 'text-stone-400'}`} data-id="element-18" data-mp="hyfw2s441m3m">
                <Icon className={`h-[22px] w-[22px] ${isActive ? 'text-brand-600' : 'text-stone-400'}`} data-id="element-19" data-mp="1p9tv4ojrrwjn" />
                <span className="text-[10px] font-semibold leading-none" data-id="element-20" data-mp="1k969kieb87wt">
                  {tab.label}
                </span>
              </button>
            </li>;
      })}

        <li className="flex-1" data-id="element-21" data-mp="1bcdpvgd7m8th">
          <button onClick={onOpenMore} aria-expanded={isMoreOpen} className={`flex w-full flex-col items-center gap-1 px-1 py-2.5 transition-colors ${isMoreOpen ? 'text-brand-700' : 'text-stone-400'}`} data-id="element-22" data-mp="16ay5lqiuw6c5">
            <MoreHorizontalIcon className={`h-[22px] w-[22px] ${isMoreOpen ? 'text-brand-600' : 'text-stone-400'}`} data-id="element-23" data-mp="wj221zy03o0j" />
            <span className="text-[10px] font-semibold leading-none" data-id="element-24" data-mp="njx4owy6e0py">Mere</span>
          </button>
        </li>
      </ul>
    </nav>;
}